enum AnalysisScopeType {
  CORRECTNESS = 'CORRECTNESS',
  TIME = 'TIME',
}

export { AnalysisScopeType }
